import { useMemo } from "react";
import { Product } from "@/services/productService";

const useProductSizeTypes = (product: Product) => {
  return useMemo(() => {
    const productSizes = product.sizes || [];
    return productSizes.map(size => size.sizeType);
  }, [product]);
};

export default useProductSizeTypes;
